import React, { useRef, useState, useEffect } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';
import FamilyTree from './FamilyTree';
import FamilyStats from './FamilyStats';
import { parseGedcomToTree } from '../utils/gedcomParser';
import './FamilyTree.css';
import './EnhancedComponents.css';

const Rossetti = () => {
  const galleryRef = useRef();
  const [isFamilyTreeOpen, setIsFamilyTreeOpen] = useState(false);
  const [gedcomData, setGedcomData] = useState(null);
  const [showMore, setShowMore] = useState(false);

  const handleViewPhotos = () => {
    galleryRef.current?.openGallery(0);
  };

  // Load GEDCOM data for stats
  useEffect(() => {
    const loadGedcomData = async () => {
      try {
        const response = await fetch('/data/rossetti.ged');
        if (response.ok) {
          const content = await response.text();
          const parsed = parseGedcomToTree(content);
          setGedcomData(parsed);
        }
      } catch (error) {
        console.error('Error loading GEDCOM data for stats:', error);
      }
    };
    
    loadGedcomData();
  }, []);

  const handleFamilyTree = () => {
    setIsFamilyTreeOpen(true);
  };

  const handleFamilyTreeOriginal = () => {
	window.open('https://rossetti.marcodemarco.net', '_blank', 'noopener,noreferrer');
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="rossetti" className="section rossetti-section">
      <div className="section-header">
        <img src="/images/rossetti.png" alt="Rossetti" className="section-icon" />
        <h1>Rossetti</h1>
      </div>
      <p>
	  	Our Rossetti family tree begins with <b>Pasquale Rossetti & Maria Giovannina de Filippo</b> and continues today with their many descendants, some that immigrated to Canada & America, many others staying in Italy.
		The family has remained in touch, across borders, oceans & generations. This site is dedicated in maintaining that family bond for the future generations to come.
      </p>

      {showMore && (
          <div className="extended-intro">
            <p>Rossetti is a diminutive form of a truly ancient nickname surname. It derives from the Roman (Latin) "russius", meaning red, and describes essentially light complexioned and fair-haired people. It can be said with confidence that this "nickname" would not originally have been bestowed lightly or as a form of endearment, it was given to the invading red-haired Huns and Goths of the 5th Century A.D. by the dark-skinned Latins.</p>
            <p>The most popular form of the surname is probably Rous(e) or Russell, although the variant forms run into dozens if not hundreds ranging from Le Roux, to Rossey, Rossoni and Rossetti.</p>
            <p>Surnames became necessary when governments introduced personal taxation. In England this was known as Poll Tax. Throughout the centuries, surnames in every country have continued to "develop" often leading to astonishing variants of the original spelling.</p>
            <p>Every European nation has its phalanx of "red" surnames. Probably the earliest known recording in any form is that of Russel of Bury St. Edmunds, Suffolk in 1095, although the first true surname may well be Robert Russel in the Winton Rolls of Hampshire in 1115.</p>
            <p>Early Italian Notables of the Rossetti family include Jacoppi Rossi in 1176; Gherardo Rossi in 1197; and Beringhieri Rossi in 1204. The first French recorded spelling of the family name is shown to be that of Jean Rossin, which was dated September 20th 1639, a christening witness at Tourouvre, Orne, France, during the reign of King Louis XIII of France, 1610 - 1643.</p>
            <p>The Rossetti surname in Italy was first found in the cities of Trento, Udine, Vicenza, Venice, Savigliano, Pisa, Ravenna, Rome, and Castel Campagnano, Province of Caserta. Some of the family migrated even further south into Sicily. This southern branch of the family descended from Count Ugone Rosso of Sicily, whose ancestors were Normans.</p>
          </div>
        )}
		
      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-shield"></i>
          {showMore ? 'Less' : 'The Rossetti Heritage'}
        </button>
	</div>

      <FamilyStats gedcomData={gedcomData} onViewTree={handleFamilyTree} />

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleFamilyTreeOriginal}>
          <i className="fas fa-sitemap"></i>
          Family Tree 1.0
        </button>
		
     	<button className="cta-btn secondary" onClick={handleViewPhotos}>
          <i className="fas fa-store"></i>
          Photo Gallery
        </button>

	</div>

	<Gallery ref={galleryRef} images={galleryData.rossetti} sectionName=" " maxDisplay={4} />

      {isFamilyTreeOpen && (
        <FamilyTree 
          onClose={handleFamilyTree}
        />
      )}
    </section>
  );
};

export default Rossetti;
